import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { catchError, EMPTY, from, of, switchMap } from 'rxjs';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './app.actions';

declare global {
    interface Window {
        mtls: {
            loaded: boolean;
            scan: () => void;
        };
    }
}
@Injectable()
export class AppEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly dealerApi = inject(DealerApiService);
    protected readonly platformId = inject(PLATFORM_ID);

    loadDealerList$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadDealerList),
            switchMap(() => {
                return from(this.dealerApi.getDealerList()).pipe(
                    switchMap(({ dealers }) => [actions.loadDealerListSuccess({ dealers })]),
                    catchError((error) => of(actions.loadDealerListFailure({ error }))),
                );
            }),
        );
    });

    matelsoScan$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(ROUTER_NAVIGATED),
                switchMap(() => {
                    if (isPlatformBrowser(this.platformId) && window.mtls.loaded) {
                        window.mtls.scan();
                        console.log('Matelso scan executed');
                    }
                    return EMPTY;
                }),
            );
        },
        { dispatch: false },
    );
}
